<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 异常账号默认 --> 
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.abnorMal1") }}</span>
                <div class="main">
                    <p>
                        <!-- 编辑异常账号默认设置 -->

                        <el-button @click="edit_abnormai()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal7") }}</el-button>
                        <el-alert :title="this.show_hind1" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName">
                            <el-table-column prop="TYPE" :label="$t('logs.abnorMal8')">
                            </el-table-column>
                            <el-table-column prop="VALUE" :label="$t('logs.abnorMal9')">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop_one" v-show="tanchu" v-loading v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.abnorMal7')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外发邮件数（大于等于）-->
                                    {{ this.abnoutmsgcn1 }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 内部邮件数（小于等于）-->
                                    {{ this.abninnermsgcn1 }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abninnermsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 不同IP认证数（大于等于）-->
                                    {{ this.abnipcn1 }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnipcn" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_abnormai()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                            <el-button type="danger" @click="off_abnormai()">{{
                  $t("logs.save_b")
                }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 弱密码判定默认 -->
            <el-tab-pane label="">
                <span slot="label">{{ $t("logs.abnorMal2") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="edit_weakpass()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal10") }}</el-button>
                        <el-alert :title="this.show_hind2" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="TYPE" :label="$t('logs.abnorMal8')" width="200">
                            </el-table-column>
                            <el-table-column prop="HINT" :label="$t('logs.abnorMal11')">
                            </el-table-column>

                            <el-table-column prop="SHOW_VALUE" :label="$t('logs.abnorMal9')" width="100">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up1" v-show="tanchu" v-drag="{ handle: '.pop_up_text_relay_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain_edit"><span class="span_pad"></span> {{$t('logs.abnorMal10')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码最小长度 --> {{this.minpwdlen1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="minpwdlen" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定IP数 --> {{this.chkweakpwdminipcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminipcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定邮件数 --> {{this.chkweakpwdminoutmsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码检查 --> {{this.chkweakpwd1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="chkweakpwd">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码拒绝 --> {{this.rejectweakpwduser1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="rejectweakpwduser">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查弱密码库 --> {{this.pwdneedchkdb1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkdb">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含数字 --> {{this.pwdneeddigit1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeddigit">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含字母 --> {{this.pwdneedchar1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchar">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 字母需大小写 --> {{this.pwdneeduplower1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeduplower">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含特殊符号 --> {{this.pwdneedspecial1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedspecial">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查包含用户名 --> {{this.pwdneedchkself1}}:
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkself">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_weakpass()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                            <el-button type="danger" @click="off_weakpass()">{{
                  $t("logs.save_b")
                }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 异常账号个性化 -->
            <el-tab-pane label="">
                <span slot="label">{{ $t("logs.abnorMal3") }}</span>
                <div class="main">
                    <p>
                        <!-- 添加异常账号个性化设置 -->

                        <el-button @click="edit_abnormai()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal12") }}</el-button>
                        <el-alert :title="this.show_hind3" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList3" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <el-table-column prop="ABNORMAL_EMAIL" :label="$t('logs.autu5_a2')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">

                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ldap_list(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑 -->
                                    <el-button @click="edit_ldap_list(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop_one" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.abnorMal12')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 邮箱账号 -->email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外发邮件数 -->{{this.abnoutmsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 内部邮件数 -->{{this.abninnermsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abninnermsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 不同IP认证数 -->{{this.abnipcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnipcn" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_pol()" :disabled="$root.jurisdiction.only_query == 0">{{$t("logs.save_a") }}</el-button>
                            <el-button type="danger" @click="off_pol()">{{$t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up pop_one" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.abnorMal12_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 邮箱账号 -->email:
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.email}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 外发邮件数 -->{{this.abnoutmsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 内部邮件数 -->{{this.abninnermsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abninnermsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 不同IP认证数 -->{{this.abnipcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="abnipcn" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_pol()" :disabled="$root.jurisdiction.only_query == 0">{{$t("logs.save_a") }}</el-button>
                            <el-button type="danger" @click="off_edit_pol()">{{$t("logs.save_b") }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 弱密码判定个性化 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.abnorMal4") }}</span>
                <div class="main">
                    <p>
                        <!-- 编辑弱密码判定个性化设置 -->

                        <el-button @click="edit_weakpass()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal13") }}</el-button>
                        <el-alert :title="this.show_hind4" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList4" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <el-table-column prop="WEAKPASS_EMAIL" :label="$t('logs.autu5_a2')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">

                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_weakpass_pol(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑 -->
                                    <el-button @click="edit_weakpass_pol(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up pop-up1" v-show="tanchu" v-drag="{ handle: '.pop_up_text_ipcor' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor"><span class="span_pad"></span> {{$t('logs.abnorMal13')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 邮箱账号 -->Email :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码最小长度 --> {{this.minpwdlen1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="minpwdlen" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定IP数 --> {{this.chkweakpwdminipcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminipcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定邮件数 --> {{this.chkweakpwdminoutmsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码检查 --> {{this.chkweakpwd1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="chkweakpwd">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码拒绝 --> {{this.rejectweakpwduser1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="rejectweakpwduser">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查弱密码库 --> {{this.pwdneedchkdb1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkdb">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含数字 --> {{this.pwdneeddigit1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeddigit">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含字母 --> {{this.pwdneedchar1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchar">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 字母需大小写 --> {{this.pwdneeduplower1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeduplower">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含特殊符号 --> {{this.pwdneedspecial1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedspecial">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查包含用户名 --> {{this.pwdneedchkself1}}:
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkself">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_weakpass_pol()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                            <el-button type="danger" @click="off_weakpass_pol()">{{
                  $t("logs.save_b")
                }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up pop-up1" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_ipcor_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_ipcor_edit"><span class="span_pad"></span> {{$t('logs.abnorMal13_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 邮箱账号 -->Email :
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.email}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码最小长度 --> {{this.minpwdlen1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="minpwdlen" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定IP数 --> {{this.chkweakpwdminipcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminipcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码判定邮件数 --> {{this.chkweakpwdminoutmsgcn1}} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="chkweakpwdminoutmsgcn" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码检查 --> {{this.chkweakpwd1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="chkweakpwd">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 弱密码拒绝 --> {{this.rejectweakpwduser1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="rejectweakpwduser">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查弱密码库 --> {{this.pwdneedchkdb1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkdb">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含数字 --> {{this.pwdneeddigit1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeddigit">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含字母 --> {{this.pwdneedchar1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchar">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 字母需大小写 --> {{this.pwdneeduplower1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneeduplower">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 密码需包含特殊符号 --> {{this.pwdneedspecial1}} :
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedspecial">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 检查包含用户名 --> {{this.pwdneedchkself1}}:
                                </div>
                                <div class="block block1">
                                    <el-radio-group v-model="pwdneedchkself">
                                        <el-radio :label="1">{{$t("logs.Policy_comb12")}}</el-radio>
                                        <el-radio :label="0">{{$t("logs.Policy_comb13") }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_weakpass_pol()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                            <el-button type="danger" @click="off_edit_weakpass_pol()">{{
                  $t("logs.save_b")
                }}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
            <!-- 弱密码库管理 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.abnorMal5") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_pass_lib()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal14") }}</el-button>

                        <el-button @click="in_pass_lib()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal16") }}</el-button>
                        <el-button @click="out_pass_lib()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal17") }}</el-button>
                        <el-alert :title="this.show_hind5" type="warning" show-icon :closable="false"></el-alert>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList5" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <el-table-column prop="WEAK_PASS" :label="$t('logs.abnorMal18')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">

                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_pass_lib(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_tan_pass_lib" v-drag="{ handle: '.pop_up_text_tls_address' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_tls_address"><span class="span_pad"></span> {{$t('logs.abnorMal14')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.abnorMal18") }} :
                                </div>
                                <div class="block block1">

                                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4}" placeholder="" v-model="weak_pass" style="margin:10px 0">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_pass_lib()" :disabled="$root.jurisdiction.only_query == 0">{{$t("logs.save_a")}}</el-button>
                            <el-button type="danger" @click="off_pass_lib()">{{$t("logs.save_b")}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_tan_pass_lib"></div>
                    <div class="pop-up" v-show="tanchu_add" v-drag="{ handle: '.pop_up_text_import_br' }"
            >
              <div class="pop_up_text  pop_up_text_import_br">
                <span style="padding:0 14px"></span>{{ $t("logs.abnorMal16") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save022">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save23()">{{$t('tan.cancel')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_add"></div>
                </div>
            </el-tab-pane>
            <!-- 内容滥发管理 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.abnorMal6") }}</span>
                <div class="main">
                    <p>
                        <span class="main_text"> {{ $t("logs.abnorMal21") }}:</span>
                        <el-select v-model="defaut_act" placeholder="请选择" style="width:140px;margin:0 10px">
                            <el-option v-for="item in defaut_act_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button @click="tan_abuse_save()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>
                        <el-button @click="tan_abuse_add()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal19") }}</el-button>
                        <el-button @click="tan_abuse_url()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.abnorMal20") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList6" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100">
                            </el-table-column>
                            <el-table-column prop="EMAIL" label="Email">
                            </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.manage4')">
                            </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="120">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_abuse_add(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑 -->
                                    <el-button @click="edit_abuse_add(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu_abuse_add"  v-drag="{ handle: '.pop_up_text_url_b' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_b"><span class="span_pad"></span> {{$t('logs.abnorMal19')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="email_abuse" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.manage4") }}:
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择" style="width:100px">
                                        <el-option v-for="item in defaut_act_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_abuse_add()" :disabled="$root.jurisdiction.only_query == 0">{{$t("logs.save_a")}}</el-button>
                            <el-button type="danger" @click="off_abuse_add()">{{$t("logs.save_b")}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_abuse_add"></div>
                    <div class="pop-up" v-show="tanchu_abuse_url" v-drag="{ handle: '.pop_up_text_Upload' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_Upload"><span class="span_pad"></span> {{$t('logs.abnorMal20')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.firewall2_a4") }}:
                                </div>
                                <div class="block block1">
                                    <el-select v-model="protocol" placeholder="请选择" style="width:100px">
                                        <el-option v-for="item in protocol_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Url:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="url" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.abnorMal22") }}:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="cont_abuse_dft_num" placeholder=""></el-input>
                                </div>
                            </div>

                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_abuse_url()" :disabled="$root.jurisdiction.only_query == 0">{{$t("logs.save_a")}}</el-button>
                            <el-button type="danger" @click="off_abuse_url()">{{$t("logs.save_b")}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_abuse_url"></div>
                    <div class="pop-up" v-show="tanchu_edit" v-drag="{ handle: '.pop_up_text_url_w' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_url_w"><span class="span_pad"></span> {{$t('logs.abnorMal19_edit')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    Email:
                                </div>
                                <div class="block block1">
                                    <span style="text-align:left;color:#0e2c5e">{{this.email_abuse}}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.manage4") }}:
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择" style="width:100px">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" :disabled="$root.jurisdiction.only_query == 0" @click="edit_save_abuse_add()">{{$t("logs.save_a")}}</el-button>
                            <el-button type="danger" @click="off_edit_abuse_add()">{{$t("logs.save_b")}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_edit"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            tanchu_edit: false,
            defaut_act: 'NO-QUICK',
            defaut_act_arr: [],
            cont_abuse_dft_num: '',
            url: '',
            protocol: 'http',
            protocol_arr: [],
            type: 'NO-QUICK',
            type_arr: [],
            email_abuse: '',
            tanchu_abuse_add: false,
            tanchu_abuse_url: false,
            tanchu_add: false,
            // 密码库管理
            tanchu_tan_pass_lib: false,
            weak_pass: '',
            // 异常账号个性化
            email: '',

            email1: '',

            // 弱密码判定默认
            chkweakpwd: 1,
            rejectweakpwduser: 0,
            minpwdlen: "",
            chkweakpwdminipcn: "",
            chkweakpwdminoutmsgcn: "",
            pwdneedchkdb: 1,
            pwdneeddigit: 1,
            pwdneedchar: 1,
            pwdneeduplower: 1,
            pwdneedspecial: 1,
            pwdneedchkself: 1,
            chkweakpwd1: "",
            rejectweakpwduser1: "",
            minpwdlen1: "",
            chkweakpwdminipcn1: "",
            chkweakpwdminoutmsgcn1: "",
            pwdneedchkdb1: "",
            pwdneeddigit1: "",
            pwdneedchar1: "",
            pwdneeduplower1: "",
            pwdneedspecial1: "",
            pwdneedchkself1: "",
            // 异常账号默认
            abnoutmsgcn: "",
            abninnermsgcn: "",
            abnipcn: "",
            abnoutmsgcn1: "",
            abninnermsgcn1: "",
            abnipcn1: "",
            //
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            fileList5: [],
            fileList6: [],
            radio: [],
            files: '',
            loading: false,
            show_hind1: '',
            show_hind2: '',
            show_hind3: '',
            show_hind4: '',
            show_hind5: '',
            data_loadok1: '',
            data_loadok2: '',
            data_loadok3: '',
            data_loadok4: '',
            data_loadok5: '',
        };
    },
    mounted() {
        this.getFileList1()
        this.getFileList_weakpass()

        this.getFileList_3()
        this.getFileList_4()
        this.getFileList_5()
        this.getFileList_6()
    },
    methods: {
        getFileList_6() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_cont_abuse_cfg",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList6 = res.data.ret.datalist;

                        this.show_hind6 = res.data.ret.LOAD_HINT
                        this.defaut_act = res.data.ret.need_check
                        this.defaut_act_arr = res.data.ret.q_type
                        this.type_arr = res.data.ret.q_in_type

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
        // 弱密码库管理
        getFileList_5() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_weakpass_lib",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList5 = res.data.ret.datalist;

                        this.show_hind5 = res.data.ret.LOAD_HINT

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
        // 弱密码判定个性化
        getFileList_4() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_weakpass_email_pol",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList4 = res.data.ret.datalist;

                        this.show_hind4 = res.data.ret.LOAD_HINT

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
        // 异常账号个性化
        getFileList_3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_abnormal_email_pol",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
             this.loading = false;

                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList3 = res.data.ret.datalist;

                        this.show_hind3 = res.data.ret.LOAD_HINT

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },

        // 加载
        getFileList_weakpass() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_weakpass_email_default",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList2 = res.data.ret.datalist;
                        this.show_hind2 = res.data.ret.LOAD_HINT

                        this.chkweakpwd1 = res.data.ret.chkweakpwd
                        this.chkweakpwdminipcn1 = res.data.ret.chkweakpwdminipcn
                        this.chkweakpwdminoutmsgcn1 = res.data.ret.chkweakpwdminoutmsgcn
                        this.minpwdlen1 = res.data.ret.minpwdlen
                        this.pwdneedchar1 = res.data.ret.pwdneedchar
                        this.pwdneedchkdb1 = res.data.ret.pwdneedchkdb
                        this.pwdneedchkself1 = res.data.ret.pwdneedchkself
                        this.pwdneeddigit1 = res.data.ret.pwdneeddigit
                        this.pwdneedspecial1 = res.data.ret.pwdneedspecial
                        this.pwdneeduplower1 = res.data.ret.pwdneeduplower
                        this.rejectweakpwduser1 = res.data.ret.rejectweakpwduser

                        this.loading = false;

                    }
                })
               
        },
        // 加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_abnormal_email_default",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList = res.data.ret.datalist;

                        this.show_hind1 = res.data.ret.LOAD_HINT
                        this.abnoutmsgcn1 = res.data.ret.abnoutmsgcn
                        this.abnipcn1 = res.data.ret.abnipcn
                        this.abninnermsgcn1 = res.data.ret.abninnermsgcn
                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
        del_abuse_add(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_cont_abuse_cfg",
                                sid: sid,
                                email: row.EMAIL

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList_6()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        edit_save_abuse_add() {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_cont_abuse_cfg",
                        sid: sid,
                        email: this.email_abuse,

                        type: this.type,
                        newadd: 0

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false;

                        this.getFileList_6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_edit_abuse_add() {
            this.tanchu_edit = false
        },
        edit_abuse_add(indes, row) {
            // console.log(indes, row)
            this.tanchu_edit = true
            this.email_abuse = row.EMAIL
            this.type = row.SHOW_TYPE
        },
        // 内容滥发url
        save_abuse_url: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_dft_cont_abuse",
                        sid: sid,
                        protocol: this.protocol,
                        url: this.url,
                        cont_abuse_dft_num: this.cont_abuse_dft_num,
                        newadd: 1

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_abuse_url = false;

                        this.getFileList_6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },

        off_abuse_url: function () {
            this.tanchu_abuse_url = false;
        },
        tan_abuse_url: function () {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "list_cont_abuse_default",
                        sid: sid,
                        email: this.email_abuse,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.cont_abuse_dft_num = res.data.ret.CONT_ABUSE_DFT_NUM
                        this.url = res.data.ret.URL
                        this.protocol = res.data.ret.PROTOCOL
                        this.protocol_arr = res.data.ret.q_type

                        this.tanchu_abuse_url = true
                    }

                })

        },
        // 内容滥发用户
        save_abuse_add: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_cont_abuse_cfg",
                        sid: sid,
                        email: this.email_abuse,
                        type: this.type

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_abuse_add = false;
                        this.getFileList_6()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })

        },

        off_abuse_add: function () {
            this.tanchu_abuse_add = false;
        },
        tan_abuse_add: function () {
            this.tanchu_abuse_add = true;
            this.email_abuse = ""
        },
        // 内容滥发保存
        tan_abuse_save() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_cont_abuse_dft_pol",
                        sid: sid,
                        defaut_act: this.defaut_act

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.getFileList_check()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })

        },
        // 弱密码导出
        out_pass_lib() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            console.log(sid);

            let __mode = "download_weakpass";
            console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/newspam.cgi?__mode=${__mode}&sid=${sid}`);

        },
        inputFileChange(e) {

            this.files = e.target.files[0];
            // console.log(this.files);
        },
        save23() {
            this.tanchu_add = false;
            this.$refs.clearFile.value = ''
        },
        // 白名单增加
        save022() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
            
                this.loading=true
                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "import_weakpass");
                fd.append("sid", sid);
                

   
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/newspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                 
                }).then((res) => {
                    // console.log(res);
                        this.loading = false;
                 
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_add = false;


                        // this.getFileList_set();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)
                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                    }
                      this.getFileList_5()
                });
            }
        },
        in_pass_lib() {
            this.tanchu_add = true
             console.log(this.files,'是否文件')
        },
        del_pass_lib(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_weakpass",
                                sid: sid,
                                id: row.ID

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList_5()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        // 弱密码库添加
        save_pass_lib: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_weakpass",
                        sid: sid,
                        weak_pass: this.weak_pass

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_tan_pass_lib = false;

                        this.getFileList_5()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })

        },

        off_pass_lib: function () {
            this.tanchu_tan_pass_lib = false;
        },
        tan_pass_lib: function () {
            this.weak_pass = ''
            this.tanchu_tan_pass_lib = true;
        },
        del_weakpass_pol(index, row) {
            console.log(row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_weakpass_email_pol",
                                sid: sid,
                                email: row.WEAKPASS_EMAIL

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList_4()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_edit_weakpass_pol: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_weakpass_email_pol",
                        sid: sid,
                        chkweakpwd: this.chkweakpwd,
                        chkweakpwdminipcn: this.chkweakpwdminipcn,
                        chkweakpwdminoutmsgcn: this.chkweakpwdminoutmsgcn,
                        data_loadok: this.data_loadok2,
                        pwdneedchar: this.pwdneedchar,
                        minpwdlen: this.minpwdlen,
                        pwdneedchkdb: this.pwdneedchkdb,
                        pwdneedchkself: this.pwdneedchkself,
                        pwdneeddigit: this.pwdneeddigit,
                        pwdneedspecial: this.pwdneedspecial,
                        pwdneeduplower: this.pwdneeduplower,
                        rejectweakpwduser: this.rejectweakpwduser,
                        email: this.email,
                        newadd: 0,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false;

                        this.getFileList_4()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_edit_weakpass_pol() {
            this.tanchu_edit = false
        },
        // 异常账号个性化 baini
        edit_weakpass_pol(index, row) {
            console.log(index, row)
            this.tanchu_edit = true

            this.email = row.WEAKPASS_EMAIL
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_weakpass_email_pol",
                        sid: sid,

                        email: this.email,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.chkweakpwd = res.data.ret.CHKWEAKPWD
                        this.chkweakpwdminipcn = res.data.ret.CHKWEAKPWDMINIPCN
                        this.chkweakpwdminoutmsgcn = res.data.ret.CHKWEAKPWDMINOUTMSGCN
                        this.minpwdlen = res.data.ret.MINPWDLEN
                        this.pwdneedchar = res.data.ret.PWDNEEDCHAR
                        this.pwdneedchkdb = res.data.ret.PWDNEEDCHKDB
                        this.pwdneedchkself = res.data.ret.PWDNEEDCHKSELF
                        this.pwdneeddigit = res.data.ret.PWDNEEDDIGIT
                        this.pwdneedspecial = res.data.ret.PWDNEEDSPECIAL
                        this.pwdneeduplower = res.data.ret.PWDNEEDUPLOWER
                        this.rejectweakpwduser = res.data.ret.REJECTWEAKPWDUSER

                    }
                })

        },
        del_ldap_list(index, row) {
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                    this.$axios
                        .get("/api/adm/cgi/newspam.cgi", {
                            params: {
                                __mode: "del_abnormal_email_pol",
                                sid: sid,
                                email: row.ABNORMAL_EMAIL

                                // screen: "real_filterlog.html",
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList_3()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_edit_pol: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_abnormal_email_pol",
                        sid: sid,
                        abninnermsgcn: this.abninnermsgcn,
                        abnipcn: this.abnipcn,
                        abnoutmsgcn: this.abnoutmsgcn,
                        data_loadok: this.data_loadok1,
                        email: this.email,
                        newadd: 0,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false;

                        this.getFileList_3()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_edit_pol() {
            this.tanchu_edit = false
        },
        // 异常账号个性化 baini
        edit_ldap_list(index, row) {
            // console.log(index, row)
            this.tanchu_edit = true

            this.email = row.ABNORMAL_EMAIL
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_abnormal_email_pol",
                        sid: sid,

                        email: this.email,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.abninnermsgcn = res.data.ret.ABNINNERMSGCN
                        this.abnipcn = res.data.ret.ABNIPCN
                        this.abnoutmsgcn = res.data.ret.ABNOUTMSGCN

                    }
                })

        },
        save_pol: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_abnormal_email_pol",
                        sid: sid,
                        abninnermsgcn: this.abninnermsgcn,
                        abnipcn: this.abnipcn,
                        abnoutmsgcn: this.abnoutmsgcn,
                        data_loadok: this.data_loadok1,
                        email: this.email,
                        newadd: 1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;

                        this.getFileList_3()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_pol: function () {
            this.tanchu = false;
        },
        save_weakpass_pol: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_weakpass_email_pol",
                        sid: sid,
                        chkweakpwd: this.chkweakpwd,
                        chkweakpwdminipcn: this.chkweakpwdminipcn,
                        chkweakpwdminoutmsgcn: this.chkweakpwdminoutmsgcn,
                        data_loadok: this.data_loadok2,
                        pwdneedchar: this.pwdneedchar,
                        minpwdlen: this.minpwdlen,
                        pwdneedchkdb: this.pwdneedchkdb,
                        pwdneedchkself: this.pwdneedchkself,
                        pwdneeddigit: this.pwdneeddigit,
                        pwdneedspecial: this.pwdneedspecial,
                        pwdneeduplower: this.pwdneeduplower,
                        rejectweakpwduser: this.rejectweakpwduser,
                        email: this.email,
                        newadd: 1,
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;

                        this.getFileList_4()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_weakpass_pol: function () {
            this.tanchu = false;
        },
        save_weakpass: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_dft_weakpass_email",
                        sid: sid,
                        chkweakpwd: this.chkweakpwd,
                        chkweakpwdminipcn: this.chkweakpwdminipcn,
                        chkweakpwdminoutmsgcn: this.chkweakpwdminoutmsgcn,
                        data_loadok: this.data_loadok2,
                        pwdneedchar: this.pwdneedchar,
                        minpwdlen: this.minpwdlen,
                        pwdneedchkdb: this.pwdneedchkdb,
                        pwdneedchkself: this.pwdneedchkself,
                        pwdneeddigit: this.pwdneeddigit,
                        pwdneedspecial: this.pwdneedspecial,
                        pwdneeduplower: this.pwdneeduplower,
                        rejectweakpwduser: this.rejectweakpwduser,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;

                        this.getFileList_weakpass()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_weakpass: function () {
            this.tanchu = false;
        },
        edit_weakpass: function () {
            this.email = ""
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "edit_weakpass_email_default",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.getFileList_check()
                        this.data_loadok2 = res.data.ret.ok
                        this.chkweakpwd = res.data.ret.result.chkweakpwdFrom
                        this.chkweakpwdminipcn = res.data.ret.result.chkweakpwdminipcn
                        this.chkweakpwdminoutmsgcn = res.data.ret.result.chkweakpwdminoutmsgcn
                        this.minpwdlen = res.data.ret.result.minpwdlen
                        this.pwdneedchar = res.data.ret.result.pwdneedcharFrom
                        this.pwdneedchkdb = res.data.ret.result.pwdneedchkdbFrom
                        this.pwdneedchkself = res.data.ret.result.pwdneedchkselfFrom
                        this.pwdneeddigit = res.data.ret.result.pwdneeddigitFrom
                        this.pwdneedspecial = res.data.ret.result.pwdnoneedspecialFrom
                        this.pwdneeduplower = res.data.ret.result.pwdnoneeduplowerFrom
                        this.rejectweakpwduser = res.data.ret.result.rejectweakpwduserFrom

                    }
                })
            this.tanchu = true;

        },
        // 保存
        save_abnormai: function () {
            this.$save_hint_test();
            this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_dft_abnormal_email",
                        sid: sid,
                        abninnermsgcn: this.abninnermsgcn,
                        abnipcn: this.abnipcn,
                        abnoutmsgcn: this.abnoutmsgcn,
                        data_loadok: this.data_loadok1
                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        off_abnormai: function () {
            this.tanchu = false;
        },
        edit_abnormai: function () {
            this.email = '';
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_dft_abnormal_email",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        // this.getFileList_check()
                        this.data_loadok1 = res.data.ret.ok
                        this.abninnermsgcn = res.data.ret.result.abninnermsgcn
                        this.abnipcn = res.data.ret.result.abnipcn
                        this.abnoutmsgcn = res.data.ret.result.abnoutmsgcn
                    }
                })
            this.tanchu = true;

        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

.pop-up1 {
    position: fixed;
    // padding: 20px 0;
    width: 50%;
    height: 60%;
    top: 10%;
    left: 25%;
    z-index: 101;
    display: flex;
    flex: 1;
    overflow: auto;
    flex-direction: column;
    align-items: center;
    background: white;

    border-radius: 4px;
    padding-bottom: 14px;

    //   margin-left: -12.5%;
    //   margin-top: -14%;
    .find-text {
        width: 310px;
    }
}

// 1
.main {
    display: flex;

    align-items: center;
    border: 2px solid #D2D7E6;
    // background: #f1f1f1;
    // margin: 0px;

    text-align: left;
    //   margin-top: 20px;
}

.main p {
    height: 44px;
    width: 100%;
    display: flex;
    padding-left: 10px;
    font-size: 12px;

    align-items: center;
    // line-height: 28px;
}

.pop_one {
    .find-text {
        width: 216px;
    }

    .el-input {
        width: 96%;
    }
}
</style>
